export const ActivityTaskType = {
  ToDo: 'To-do',
  Email: 'Email',
  Call: 'Call',
  Message: 'Message',
  Connection: 'Connection',
  LinkedIn: 'LinkedIn',
};

export const ActivityTaskTypeTranslationKeys = [
  { nameKey: 'ACTIVITY.TASK.TO_DO', value: ActivityTaskType.ToDo },
  { nameKey: 'ACTIVITY.TASK.EMAIL', value: ActivityTaskType.Email },
  { nameKey: 'ACTIVITY.TASK.CALL', value: ActivityTaskType.Call },
  { nameKey: 'ACTIVITY.TASK.MESSAGE', value: ActivityTaskType.Message },
  { nameKey: 'ACTIVITY.TASK.CONNECTION', value: ActivityTaskType.Connection },
  { nameKey: 'ACTIVITY.TASK.LINKEDIN', value: ActivityTaskType.LinkedIn },
];

export const ActivityDirection = {
  Outbound: 'Outbound',
  Inbound: 'Inbound',
  Forwarded: 'Forwarded',
};

export const CallStatus = {
  Connected: 'Connected',
  Busy: 'Busy',
  Rejected: 'Rejected',
  Voicemail: 'Left voicemail',
  NoAnswer: 'No answer',
  NotInService: 'Not in service',
  WrongNumber: 'Wrong number',
};

export const ActivityOutcome = {
  BusinessReview: 'Business review',
  Demo: 'Demo scheduled',
  DemoCompleted: 'Demo completed',
  Discovery: 'Discovery',
  Interested: 'Interested',
  NoInterest: 'No interest',
  Presentation: 'Presentation',
  QualityConnect: 'Quality connect',
  Rescheduling: 'Rescheduling',
  Referred: 'Referred to another contact',
  Timeline: 'Timeline 6-12 months',
};

export const MeetingDuration = {
  FiveMin: 300000,
  FifteenMin: 900000,
  ThirtyMin: 1800000,
  OneHour: 3600000,
  OneHourThirtyMin: 5400000,
  TwoHoursPlus: 7200000,
};

export const MeetingStatus = {
  Scheduled: 'Scheduled',
  Rescheduled: 'Rescheduled',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  NoShow: 'No show',
};
